import { ImageSectionElement } from "./ImageSectionElement";

export default ImageSectionElement;
